import { configureStore } from '@reduxjs/toolkit';
import serverSentEventsReducer from '@shared/serverSentEventsSlice';
import vehicleReducer from '@shared/vehicleSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { journeySlice, stopHeaderSlice } from '@shared/resourceSlices';
import {
  arrivalRowsSlice,
  departureRowsSlice,
  trafficSituationsSlice,
  extendedMessagesSlice,
} from '@shared/resourcesSlices';
import { DeepReadonly } from 'ts-essentials';

export const store = configureStore({
  reducer: {
    serverSentEvents: serverSentEventsReducer,
    stopHeaders: stopHeaderSlice.reducer,
    departureRows: departureRowsSlice.reducer,
    arrivalRows: arrivalRowsSlice.reducer,
    trafficSituations: trafficSituationsSlice.reducer,
    vehicle: vehicleReducer,
    journeys: journeySlice.reducer,
    extendedMessages: extendedMessagesSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<DeepReadonly<RootState>> =
  useSelector;
